import { useState } from "react";
import useSWR from "swr";
import { RefreshCw } from "lucide-react";
import { fmtDateTime } from "@/lib/format";
import { Card, btn, inputCls } from "@/components/common/Ornament";

const KINDS = {
  login: "Login", login_failed: "Failed login", disclaimer_ack: "Disclaimer acknowledged", doc_view: "Document viewed",
  doc_download: "Document downloaded", logout: "Logout", credentials_changed: "Passwords changed",
};
const TONE = { login_failed: "bg-red-50 text-red-700", disclaimer_ack: "bg-amber-50 text-amber-800", doc_download: "bg-emerald-50 text-emerald-800", doc_view: "bg-slate-100 text-slate-700" };

export default function LogsTab() {
  const [kind, setKind] = useState("");
  const { data = [], mutate, isValidating } = useSWR(`/admin/logs?kind=${kind}`);
  return (
    <Card eyebrow="Audit Trail" title="Access Log" testId="admin-logs"
      right={<button onClick={() => mutate()} className={btn.ghost + " !h-9"} data-testid="admin-logs-refresh"><RefreshCw className={`h-4 w-4 ${isValidating ? "animate-spin" : ""}`} /> Refresh</button>}>
      <select value={kind} onChange={(e) => setKind(e.target.value)} className={inputCls + " sm:w-64 mb-4"} data-testid="admin-logs-filter">
        <option value="">All events</option>
        {Object.entries(KINDS).map(([k, l]) => <option key={k} value={k}>{l}</option>)}
      </select>
      <div className="overflow-x-auto max-h-[600px] overflow-y-auto">
        <table className="w-full text-sm min-w-[640px]" data-testid="admin-access-log-table">
          <thead className="sticky top-0 bg-white"><tr className="border-b border-[#0F2E23] text-left text-xs uppercase tracking-wider text-[#3E5C4E]"><th className="py-2">Time</th><th>Event</th><th>Role</th><th>Detail</th><th>IP</th></tr></thead>
          <tbody>
            {data.map((l) => (
              <tr key={l.id} className="border-b border-[#E2DCD2]">
                <td className="py-2 pr-3 whitespace-nowrap font-mono-num text-xs">{fmtDateTime(l.at)}</td>
                <td className="pr-3"><span className={`inline-block rounded px-2 py-0.5 text-xs font-semibold ${TONE[l.kind] || "bg-[#0F2E23]/10 text-[#0F2E23]"}`}>{KINDS[l.kind] || l.kind}</span></td>
                <td className="pr-3 capitalize">{l.role || "—"}</td>
                <td className="pr-3 text-slate-600">{l.detail || ""}</td>
                <td className="font-mono-num text-xs text-slate-500">{l.ip}</td>
              </tr>
            ))}
            {data.length === 0 && <tr><td colSpan={5} className="py-8 text-center text-slate-500">No events yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </Card>
  );
}
